import cx from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Paper({
  isElevated,
  isFixedTop,
  children,
  className,
  ...props
}) {
  return /*#__PURE__*/_jsx("div", {
    ...props,
    className: cx('wa-paper', {
      'wa-paper--elevated': isElevated,
      'wa-paper--fixed-top': isFixedTop
    }, className),
    children: children
  });
}